<template>
  <div class="ah-vue-app">
    <search-controls/>
    <search-results/>
  </div>
</template>

<script>
  import SearchControls from './containers/SearchControls.vue'
  import SearchResults from './containers/SearchResults.vue'

  import api from './api'
  import adapter from './data/adapter'

  import { store, mutations } from './data/store'
  import getUrlParams from './utils/getQueryParams'

  export default {
  components: { SearchControls, SearchResults },
    name: 'app',
    methods: {
      activateFiltersFromParams: function(filters, params) {
        return new Promise((resolve, reject) => {
          resolve(filters.reduce((acc, current) => {
            const regex = new RegExp(current.slug, 'i')
            if (params.match(regex)) current.active = true
            acc.push(current)
            return acc
          }, []))
        })
      },
    },
    created: function() {
      const searchParams = getUrlParams('search')
      mutations.setSearchParams(searchParams)
      const filterParams = getUrlParams('filters')
      mutations.setFilterParams(filterParams)

      api.getCategories()
      .then(categories => adapter.categories(categories))
      .then(categories => this.activateFiltersFromParams(categories, filterParams))
      .then(categories => mutations.setCategories(categories))

      api.getSpecies()
      .then(species => adapter.species(species))
      .then(species => this.activateFiltersFromParams(species, filterParams))
      .then(species => mutations.setSpecies(species))

      api.getTherapies()
      .then(therapies => adapter.therapies(therapies))
      .then(therapies => this.activateFiltersFromParams(therapies, filterParams))
      .then(therapies => mutations.setTherapies(therapies))

      api.getProducts()
      .then(products => adapter.products(products))
      .then(products => mutations.setProducts(products))
    },
  }
</script>

<style lang="scss" scoped>

</style>